import React, { useEffect, useState } from "react";
// import i18next from "i18next";
import styles from "./Survey.module.css";
import Button from "../../component/Button";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchDataFromApi } from "../../api/Api";
import { sendDataToApi } from "../../api/Api";
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalBody,
} from "mdb-react-ui-kit";
import data from "./Questions";
import ButtonOld from "../../component/ButtonOld";
import i18next from "i18next";

const Survey = () => {
  const t = i18next.t;
  const navigate = useNavigate();
  const location = useLocation();
  // const [data, setData] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState();
  const [cf_response, setCf_response] = useState("");
  const [centredModal, setCentredModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [buttonEnable, setButtonEnable] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  let currentDate = new Date().toISOString().slice(0, 10);
  let currentTime = new Date().toString().slice(16, 24);
  let currentYear = new Date().toISOString().slice(0, 4);
  const cf_date = currentDate + " " + currentTime;
  const allData = location?.state?.allData;
  const avatarId = location?.state?.avatarId;
  const mobileId = location?.state?.mobileId;

  const correctData = {
    m_ulb_id: allData?.selectedCity,
    is_resident: allData?.is_resident,
    location_name: allData?.location_name,
    res_avatarId: avatarId,
    res_phone: mobileId,
    res_title: "",
    res_name: "",
    res_age: Number(allData?.age),
    res_gender: allData?.gender,
    cf_date: String(cf_date),
    cf_response: [cf_response],
    ss_period: String(currentYear),
  };

  const toggleShow = () => {
    setCentredModal(!centredModal);
  };

  const toggleClose = () => {
    if(errorMsg?.data != 4){
      navigate("/");
    }else {
      setCentredModal(!centredModal);
    }
  };

  // const fetchQuestions = () => {
  //   fetchDataFromApi(
  //     "questions/2024/C100/" + allData?.selectedState + "/" + allData?.age
  //   ).then((res) => setData(res));
  // };

  const submitAllData = () => {
    if (
      Object.keys(correctData?.cf_response[0])?.length === data?.data?.length
    ) {
      sendDataToApi("web/save", {...correctData, otp}).then((res) => {
        if (res.status) {
          navigate("/thankyou");
        } else {
          setErrorMsg(res);
          toggleShow();
        }
      });
    } else {
      alert("Please Answer to all Questions");
    }
  };

  const getSelectedLanguage = () => {
    const Language = window.localStorage.getItem("lang");
    setSelectedLanguage(Language);
  };

  useEffect(() => {
    // fetchQuestions();
    getSelectedLanguage();
  }, []);

  const onButtonClick = (e) => {
    e.preventDefault();
    submitAllData();
  };
  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };
  
    document.addEventListener("contextmenu", handleContextMenu);
  
    getSelectedLanguage();
  
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCf_response(() => ({
      ...cf_response,
      [name]: value,
    }));
  };

  const handleOtp = (e) => {
    e.preventDefault();
    setOtp(e.target.value);
  };

  const handleValidateButton = () => {
    setMinutes(1);
    setSeconds(59);
    sendDataToApi(`generate-otp/${mobileId}`, {}).then((res) => {
      if (!res.status) {
        setErrorMsg(res);
        toggleShow();
      }
    });
  };

  const handleValidateOtpButton = (e) => {
    e.preventDefault();
    const validateOtp = () => {
      fetchDataFromApi("validateOtp/" + mobileId + "/" + otp)
        .then((res) => {
          if (res.status) {
            setButtonEnable(false);
            // localStorage.setItem("login", true);
            // navigate("/selectlanguage", { state: { mobile } });
          } else {
            setErrorMsg(res);
            toggleShow();
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    };
    validateOtp();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [minutes, seconds]);

  return (
    <>
      <div className="container">
        <div className={styles.mainWrapper}>
          <div id="parentScrollDiv">
            {data?.data?.sort().map((res, index) => {
              return (
                <div key={index} className={styles.questionWrapper}>
                  <p className={styles.questionTitle}>{res.questionCode}</p>
                  <p className={styles.questionDesc}>
                    {selectedLanguage === "en" ? (
                      <>{res.questionDisplay}</>
                    ) : (
                      <>{res.languages[selectedLanguage]?.questionDisplay}</>
                    )}
                  </p>
                  {/* <div className={styles.options} onChange={handleChange}>
                    <>
                      {selectedLanguage === "en" ? (
                        <>
                          {res?.optionValues?.map((options, index) => {
                            return (
                              <label
                                htmlFor={
                                  res.questionCode + options.option_value
                                }
                                key={index}
                                className={styles.twoOptionLabel}
                              >
                                <input
                                  type="radio"
                                  id={res.questionCode + options.option_value}
                                  name={res.questionCode}
                                  value={options.option_value}
                                />
                                <div>{options.option_display}</div>
                              </label>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          {res?.languages[selectedLanguage]?.optionValues?.map(
                            (options, index) => {
                              return (
                                <label
                                  htmlFor={
                                    res.questionCode + options.option_value
                                  }
                                  key={index}
                                  className={styles.twoOptionLabel}
                                >
                                  <input
                                    type="radio"
                                    id={res.questionCode + options.option_value}
                                    name={res.questionCode}
                                    value={options.option_value}
                                  />
                                  <div>{options.option_display}</div>
                                </label>
                              );
                            }
                          )}
                        </>
                      )}
                    </>
                  </div> */}
                  <div className={styles.options} onChange={handleChange}>
  {(
    selectedLanguage === "en"
      ? res?.optionValues
      : res?.languages[selectedLanguage]?.optionValues
  )?.map((options, index) => {

    const colorClasses = [
      styles.optionGreenDark,
      styles.optionGreenLight,
      styles.optionYellow,
      styles.optionPink,
      styles.optionRed,
      styles.optionRed1,
      styles.optionRed2,
    ];

    return (
      <label
        htmlFor={res.questionCode + options.option_value}
        key={index}
        className={styles.twoOptionLabel}
      >
        <input
          type="radio"
          id={res.questionCode + options.option_value}
          name={res.questionCode}
          value={options.option_value}
        />

        {/* APPLY COLOR HERE */}
        <div className={`${styles.optionBox} ${colorClasses[index]}`}>
          {options.option_display}
        </div>
      </label>
    );
  })}
</div>
{/* Divider */}
<div className={styles.questionDivider}></div>
                </div>
              );
            })}
          </div>
          <div className={styles.otpInputFieldWrapper}>
            <label htmlFor="otp" className={styles.inputFieldLabel}>
              Enter OTP
            </label>
            <input
              value={otp}
              type="tel"
              className={styles.otpInputField}
              id="otp"
              required
              onChange={handleOtp}
              maxLength={6}
              minLength={6}
            />
          </div>
          <div className={styles.resendWrapper}>
            {seconds > 0 || minutes > 0 ? (
              <div className={styles.resendTimer}>
                Resend OTP in {minutes < 10 ? `0${minutes}` : minutes}:
                {seconds < 10 ? `0${seconds}` : seconds}
              </div>
            ) : (
              <>
                <div className={styles.resendTimer}>Didn't recieve code?</div>
              </>
            )}
            <div className={styles.resendButtonWrapper}>
              <button
                className={styles.resendButton}
                onClick={handleValidateButton}
                disabled={seconds > 0 || minutes > 0 ? true : false}
              >
                Resend OTP
              </button>
            </div>
          </div>
          {/* <>
            <button
              disabled={otp === "" || otp.length !== 6}
              className={styles.validateButton}
              type="submit"
              onClick={handleValidateOtpButton}
            >
              Validate OTP
            </button>
          </> */}
        </div>

        <div className={styles.bottomButtonWrapper}>
          <Button
            text={t("SUBMIT")}
            onClick={onButtonClick}
            disabled={otp === "" || otp.length !== 6}
          />
        </div>
         {/* Footer */}
      <div className={styles.footerStrip}>
        Powered by Swachh Bharat Mission Urban
      </div>
      </div>
      <MDBModal tabIndex="-1" show={centredModal} setShow={setCentredModal}>
        <MDBModalDialog className={styles.modalDialog} centered>
          <MDBModalContent className={styles.popupContent}>
            <MDBModalBody>
              <div className={styles.popupMainWrapper}>
                <div className={styles.popupHeaderWrapper}>
                  <p className={styles.popupHeader}>Alert Message</p>
                </div>
                <div className={styles.popupbodyWrapper}>
                  <p className={styles.popupbody}>{errorMsg?.message}</p>
                </div>
                <div>
                  <button
                    className={styles.popupCloseButton}
                    onClick={toggleClose}
                  >
                    Close
                  </button>
                </div>
              </div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
};

export default Survey;
